import React from 'react';

import './Card.css';

function FooCard(props) {

  return (
    <div className="foo-card grid-x">
      <div className="image small-12 medium-6">
        <img className={`${props.name} img-color`} src={props.fooUrl} alt="Foo card" />
      </div>
      <div className="description small-12 medium-6">
        <h2>{props.name}</h2>
        <h5>{props.title}</h5>
        <p>{props.description}</p>
      </div>
    </div>
  );
}

export default FooCard;



// WEBPACK FOOTER //
// ./src/components/elements/FooCard/index.js